"use strict";function component(t){return t.templateUrl=t.templateCacheUrl,t}exports.component=component;